export default __webpack_public_path__ + "static/media/atoka_logo.b09d3079.png";